/** post-meetup — EN source (31 keys). */
export const postMeetup = {
  post_meetup_prompt_title: "How was your meetup with {name}?",
  post_meetup_prompt_subtitle:
    "Want to exchange contact info? If you both match, your Linqx cards will be shared.",
  post_meetup_prompt_disclaimer: '"Not Now" = decline. Your choice is private.',
  post_meetup_match_button: "Match",
  post_meetup_not_now_button: "Not Now",
  post_meetup_waiting_title: "Waiting for {name} to respond...",
  post_meetup_waiting_subtitle: "You chose: Match",
  post_meetup_waiting_notify: "You'll be notified when there's a result",
  post_meetup_withdraw_button: "Withdraw",
  post_meetup_done_button: "Done",
  post_meetup_connected_title: "You're now connected!",
  post_meetup_connected_subtitle: "You can now view {name}'s Linqx card.",
  post_meetup_linqx_card_button: "Linqx Card",
  post_meetup_no_vibe_title: "It wasn't a vibe with {name}",
  post_meetup_no_vibe_subtitle: "Swipe to match with someone else!",
  post_meetup_explore_button: "Explore",
  post_meetup_expired_title: "Your match with {name} has expired",
  post_meetup_expired_subtitle: "You can still ReMatch from the chat.",
  post_meetup_go_to_chat_button: "Go to Chat",
  post_meetup_rematch_button: "ReMatch",
  post_meetup_rematch_waiting_title: "Waiting for {name} to ReMatch...",
  post_meetup_rematch_waiting_subtitle:
    "You tapped ReMatch. If {name} also ReMatches, your connection will be restored.",
  post_meetup_chat_expired_message: "This match has expired.",
  post_meetup_chat_expired_subtitle:
    "Both users need to ReMatch to continue the conversation.",
  post_meetup_remaining: "{time} remaining",
  post_meetup_confirm_title: "Did you meet {name} at {event}?",
  post_meetup_confirm_yes: "Yes, we met",
  post_meetup_confirm_not_yet: "Not yet",
  post_meetup_confirm_did_not_meet: "We didn't meet",
  post_meetup_pending_title: "AWAITING YOUR RESPONSE ({count})",
  post_meetup_pending_respond: "Respond",
};
